import type { PaymentMethod } from '@techgitter/contracts';

const API_BASE_URL = '/api';

interface PaymentMethodsResponse {
  items: PaymentMethod[];
}

export async function fetchPaymentMethods(
  signal?: AbortSignal,
): Promise<PaymentMethod[]> {
  const response = await fetch(`${API_BASE_URL}/payment-methods`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
    signal,
  });
  if (!response.ok) {
    throw new Error(
      `Failed to fetch payment methods: ${response.status} ${response.statusText}`,
    );
  }
  const data = (await response.json()) as PaymentMethodsResponse;
  return data.items ?? [];
}
